import { Routes } from '@common/constants';

export const CATEGORY_IDS = [
  'rooms',
  'rates',
  'spa',
  'treatments',
  'facilities',
  'classes',
  'dining',
] as const;

export const CATEGORY_ROUTES: Record<string, string> = {
  rooms: Routes.ROOM_LIST,
  rates: Routes.RATE_LIST,
  spa: Routes.SPA_DAY_LIST,
  treatments: Routes.SPA_TREATMENT_LIST,
  facilities: Routes.FACILITY_LIST,
  classes: Routes.SPA_CLASSES_LIST,
  dining: Routes.TABLES_HOME,
};
